export enum IdexxLabOrderStatus {
    CREATED = 'CREATED',
    SUBMITTED = 'SUBMITTED',
    CANCELLED = 'CANCELLED',
}

export enum IdexxResultStatus {
    ATLAB = 'ATLAB',
    PARTIAL = 'PARTIAL',
    COMPLETE = 'COMPLETE',
}
